import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";

import { countCreditByTask } from "../helpers";
import { OrganizationGamificationTask } from "../schema";
import CardHeader from "./CardHeader";
import CreateNicheTemplateCard from "./CreateNicheTemplateCard";

interface Props {
  numOfCardsToRender: number | null;
}

const ExperienceVa = ({ numOfCardsToRender }: Props) => {
  const { gamificationProfile, credits } = useContext(OrganizationUserContext);
  if (!gamificationProfile || numOfCardsToRender === null) {
    return <></>;
  }

  return (
    <>
      <CardHeader
        title="Niche Templates Challenges"
        description="Earn credits for creating more templates"
        icon="fa-solid fa-pen"
      />
      {Array.from({ length: numOfCardsToRender }).map((_, index) => (
        <CreateNicheTemplateCard
          key={index}
          title={
            numOfCardsToRender <= 1
              ? `Niche Template`
              : `Niche Template #${index + 1}`
          }
          description={
            index === 0
              ? "Create a pitch template for a specific niche (e.g., beauty, fitness, tech)"
              : "Create a pitch template for a second niche to diversify your opportunities"
          }
          completed={
            countCreditByTask(
              credits,
              OrganizationGamificationTask.niche_templates,
            ) >=
            index + 1
          }
          infoBox={
            <>
              {" "}
              {index === 0 && (
                <>
                  <strong>Pro tip:</strong> Different niches respond to
                  different pitching styles. A beauty brand cares about
                  aesthetics and engagement, while a tech brand wants to see
                  expertise and audience demographics.
                </>
              )}
              {index === 1 && (
                <>
                  <strong>Why a second niche?</strong> Having templates for
                  multiple niches increases your opportunities and helps you
                  understand which brand categories respond best to your content
                  style.
                </>
              )}
            </>
          }
        />
      ))}
    </>
  );
};
export default ExperienceVa;
